import React from "react";
import "./BannerPreview.scss";

const BannerPreview = ({ imageUrl, onClose }) => {
  return (
    <div className="banner-preview-overlay" onClick={onClose}>
      <div className="banner-preview-content">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <img src={imageUrl} alt="Banner Preview" />
      </div>
    </div>
  );
};

export default BannerPreview;
